import { handleTable } from "../../Tools/Requests";
import { getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import smetaAxios from "../../../SmetaAxios";

interface StaffData {
  json: any;
  groupID: string;
  orgTypeCls?: string;
  canModifyNfa: () => any;
  setSelectedRecord: (id: string) => void;
  setCountRecords: (count: number) => void;
}

export async function storobjGrid(grid: createGrid, source: createRecordSource, props: any, data: StaffData) {
  const { json, groupID, orgTypeCls, canModifyNfa, setSelectedRecord, setCountRecords } = data;

  if (json) {
    source.rights = getRightsData(json.Rights);
  }
  const gridObjType = json?.ObjType || props.ObjType;
  const columns = parseColumns(json, { collapsibleField: "Name" });
  grid.setColumns(columns);

  source.onHandleRequest = handleTable({
    Module: props.Module,
    ObjType: gridObjType,
    GroupID: groupID,
    selectedRecordID: props.ObjRef || "0",
    SectionID: props.SectionID,
    OrgTypeCls: orgTypeCls || "0",
  });
  grid.canModify = canModifyNfa;
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  source.onRecordIndexChanged = (s: createRecordSource) => {
    setSelectedRecord(s.getFieldTextSync("ID"));
  };

  source.onRecordCollapsed = async function (event) {
    const recordIndex = event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, ObjType: props.ObjType, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
  };

  grid.setImageFields(["Options"]);
  source.booksGetImage = (value) => {
    if (value & 4) return 3;
    return 0;
  };

  await grid.setSource(source);
  await grid.refreshSource(props.ObjRef || "0");
  await grid.updateGridSize();

  setCountRecords(source.recordCount);
  const id = source.getFieldTextSync("ID");
  setSelectedRecord(id);
}
